import smCom from './smCom.js'
// 合作伙伴信息
let bykPlatform = {
  partnerInfo: {},
};


// 修改 合作伙伴信息
const fSetPlatform = (obj) => {
  // 取值
  bykPlatform = JSON.parse(localStorage.bykPlatform)
  if (!smCom.fSmIsEmpty(obj.partnerInfo.phone)) {
    bykPlatform.partnerInfo.phone = obj.partnerInfo.phone
  }
  if (!smCom.fSmIsEmpty(obj.partnerInfo.data)) {
    bykPlatform.partnerInfo.data = obj.partnerInfo.data
  }
  if (!smCom.fSmIsEmpty(obj.partnerInfo.token)) {
    bykPlatform.partnerInfo.token = obj.partnerInfo.token
  }
  localStorage.setItem('bykPlatform', JSON.stringify(bykPlatform))

}

// 获取 合作伙伴信息
const fGetPlatform = () => {
  if (!localStorage.bykPlatform) {
    localStorage.setItem('bykPlatform', JSON.stringify(bykPlatform))
  }
  return JSON.parse(localStorage.bykPlatform)
}

// 判断是否拥有权限
const fGetSmMenuQx = async (menu) => {
  // 是  1001  不做权限
  if (fGetPlatform().partnerInfo.data.user_phone == '18957102098' || !menu) {
    // console.log('1001 员工 - ', menu, ' - 权限通过')
    return true
  }
  console.log(fGetPlatform().partnerInfo.data.auth_info)
  if (smCom.fSmIsEmpty(fGetPlatform().partnerInfo.data.auth_info)) {
   return false
  }
  let idx = JSON.parse(fGetPlatform().partnerInfo.data.auth_info).findIndex(item => {
    return item == menu
  })
  if (idx != -1) {
    // console.log(menu, ' - 权限通过')
    return true
  } else {
    return false
  }
}

export default {
  fSetPlatform, // 修改 合作伙伴信息
  fGetPlatform, // 获取 合作伙伴信息
  fGetSmMenuQx
}



// WEBPACK FOOTER //
// ./src/common/global/global.js